import React, { Component } from "react";
import { injectIntl } from "react-intl";
import _ from "lodash";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { GroupPage, PeoplePage } from "../../pages";
import { Layout } from "antd";
import { AppSider, AppHeader } from "../../components";
import Logo from "../../images/logo-full.svg";
import styles from "./styles.module.scss";
import {
  addPerson,
  fetchPeople,
  uploadPeopleFromFile,
  uploadPeopleFromFileConfirm,
} from "../../store/people/actions";
import {
  addGroup,
  fetchGroups,
  deleteGroup,
  updateGroup,
} from "../../store/groups/actions";
import { signOutUser } from "../../store/auth/actions";
import queryString from "querystring";
import {
  verifyVerificationCode,
  requestVerificationCode,
} from "../../store/user/actions";
import { getCookie } from "../../utils/helpers";
import EsokoHeader from "../../components/EsokoHeader/Header";

class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      siderWidth: 256,
      peopleLimit: 50,
      peoplePage: 1,
    };
  }
  componentDidMount = () => {
    const qs = queryString.parse(window.location.search);
    const query = qs["?q"];

    const {
      fetchGroups,
      userId,
      intl,
      siteLanguage,
      isAuthenticated,
      peopleLimit,
      peoplePage,
      fetchPeople,
    } = this.props;
    if (isAuthenticated) {
      fetchGroups(userId, intl, siteLanguage);
      if (!this.props.location.pathname.includes("/everyone")) {
        fetchPeople(userId, peopleLimit, peoplePage, intl, siteLanguage, query);
      }
    }
  };

  handleSiderCollapse = () => {
    this.setState((state, props) => ({
      collapsed: !state.collapsed,
    }));
  };
  getPaddingLeft = (collapsed, siderWidth) => {
    return collapsed ? 80 : siderWidth;
  };

  getHeadWidth = () => {
    const { collapsed, siderWidth } = this.state;
    return collapsed ? "calc(100% - 80px)" : `calc(100% - ${siderWidth}px)`;
  };

  handleAddPerson = (values) => {
    const { addPerson, userId, intl, siteLanguage } = this.props;

    const { peopleLimit, peoplePage } = this.state;

    const { customDataKeys, CustomData, groups, ...personDataMessy } = values;
    let personData = _.pickBy(personDataMessy, _.identity);

    if (personData["Date of Birth"]) {
      personData["Date of Birth"] =
        personData["Date of Birth"].format("YYYY-MM-DD");
    }
    let Custom = {};
    if (CustomData) {
      CustomData.forEach((dt) => {
        Custom[dt.fieldName] = dt.fieldValue;
      });
    }
    personData["Custom"] = Custom;
    const data = {
      personData: personData,
      personMeta: { source: "dfs people", groups: groups ? [groups] : "" },
      userId,
    };

    addPerson(data, peopleLimit, peoplePage, userId, intl, siteLanguage);
  };

  signOutUser = () => {
    const { signOutUser, userId, intl, siteLanguage } = this.props;
    signOutUser(userId, intl, siteLanguage);
  };

  handelDeleteGroup = (group) => {
    const { deleteGroup, userId, intl, siteLanguage, match } = this.props;

    deleteGroup(group.uuid, userId, intl, siteLanguage, match);
  };
  addGroup = (values, userId, intl, siteLanguage) => {
    if (values.groupId) {
      this.props.updateGroup(
        values.groupId,
        { name: values.name },
        userId,
        intl,
        siteLanguage
      );
    } else {
      this.props.addGroup(values, userId, intl, siteLanguage);
    }
  };
  uploadPeopleFromFile = (values) => {
    const {
      uploadPeopleFromFile,
      userId,
      intl,
      siteLanguage,
      peopleLimit,
      peoplePage,
    } = this.props;
    uploadPeopleFromFile(
      values,
      peopleLimit,
      peoplePage,
      userId,
      intl,
      siteLanguage
    );
  };
  uploadPeopleFromFileConfirm = (data) => {
    const {
      uploadPeopleFromFileConfirm,
      userId,
      intl,
      siteLanguage,
      peopleLimit,
      peoplePage,
    } = this.props;
    uploadPeopleFromFileConfirm(
      data,
      peopleLimit,
      peoplePage,
      userId,
      intl,
      siteLanguage
    );
  };

  render() {
    const {
      siteLanguage,
      location,
      intl,
      userId,
      addingPerson,
      screen,
      addingGroup,
      groupCreated,
      fetchingGroups,
      groups,
      subGroups,
      systemGroups,
      numberOfGroups,
      numberOfPeople,
      pageTitle,
      personAdded,
      fetchedGroupId,
      fetchingPerson,
      uploadedPeople,
      uploadingPeopleFromFile,
      peopleUploaded,
      uplodPeopleError,
      numberOfGroupPeople,
      totalNumberOfPeople,
      fileName,
      groupName,
      parentGroupId,
      parentGroupName,
      groupType,
      peopleQuery,
      groupQuery,
      totalNumberOfGroupPeople,
      status,
      msisdn,
      email,
      requestingVerifyToken,
      verificationCodeRequested,
      verifyingUser,
      verifyVerificationCode,
      requestVerificationCode,
    } = this.props;

    const { siderWidth, collapsed } = this.state;
    const width = this.getHeadWidth();
    const user = JSON.parse(getCookie("user"));
    let query = location.pathname.includes("/everyone")
      ? peopleQuery
      : groupQuery;
    return (
      <Layout hasSider={true}>
        <EsokoHeader
          user={user}
          account={{ name: "People Management System" }}
          signOut={this.signOutUser}
          app="people"
        />
        <AppSider
          siteLanguage={siteLanguage}
          onCollapse={this.handleSiderCollapse}
          collapsed={collapsed}
          width={siderWidth}
          logo={Logo}
          title="People"
          location={location}
          intl={intl}
          addGroup={this.addGroup}
          addingGroup={addingGroup}
          userId={userId}
          groupCreated={groupCreated}
          fetchingGroups={fetchingGroups}
          groups={groups}
          systemGroups={systemGroups}
          numberOfGroups={numberOfGroups}
          numberOfPeople={numberOfPeople}
          totalNumberOfPeople={totalNumberOfPeople}
          handelDeleteGroup={this.handelDeleteGroup}
        />
        <Layout
          className={styles.contentLayout}
          style={{
            paddingLeft: this.getPaddingLeft(collapsed, siderWidth),
            minHeight: "100vh",
          }}
        >
          <AppHeader
            parentGroupName={parentGroupName}
            currentGroup={{ groupName, groupType, parentId: parentGroupId }}
            subGroups={subGroups}
            siteLanguage={siteLanguage}
            systemGroups={systemGroups}
            intl={intl}
            userId={userId}
            width={width}
            onAddPerson={this.handleAddPerson}
            addingPerson={addingPerson}
            screen={screen}
            signOutUser={this.signOutUser}
            pageTitle={pageTitle}
            groups={groups}
            personAdded={personAdded}
            fetchedGroupId={fetchedGroupId}
            fetchingPerson={fetchingPerson}
            uploadPeopleFromFile={this.uploadPeopleFromFile}
            uploadedPeople={uploadedPeople}
            uploadingPeopleFromFile={uploadingPeopleFromFile}
            peopleUploaded={peopleUploaded}
            uplodPeopleError={uplodPeopleError}
            uploadPeopleFromFileConfirm={this.uploadPeopleFromFileConfirm}
            fileName={fileName}
            location={location}
            numberOfPeople={numberOfPeople}
            totalNumberOfPeople={totalNumberOfPeople}
            numberOfGroupPeople={numberOfGroupPeople}
            totalNumberOfGroupPeople={totalNumberOfGroupPeople}
            query={query}
            status={status}
            msisdn={msisdn}
            email={email}
            requestingVerifyToken={requestingVerifyToken}
            verificationCodeRequested={verificationCodeRequested}
            verifyingUser={verifyingUser}
            verifyVerificationCode={verifyVerificationCode}
            requestVerificationCode={requestVerificationCode}
          />
          <Layout.Content className={styles.content}>
            <Switch>
              <Route
                exact
                name="Everyone"
                path="/:lang/everyone"
                // render={() => <PeoplePage screen={screen} />}
                component={PeoplePage}
              />
              <Route
                name="Group"
                path="/:lang/groups/:groupId"
                // render={(props) => <GroupPage {...props} groupName={groupName}   parentGroupName={parentGroup && parentGroup.name} />}
                component={GroupPage}
              />
              <Route
                name="Search"
                path="/:lang/search"
                component={PeoplePage}
              />
              <Redirect from="/" to={`/${siteLanguage || "en"}/everyone`} />
            </Switch>
          </Layout.Content>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  siteLanguage: state.intl.siteLanguage,
  isAuthenticated: state.user.isAuthenticated,
  userId: state.user.userId,
  addingPerson: state.people.addingPerson,
  addingGroup: state.groups.addingGroup,
  groupCreated: state.groups.groupCreated,
  fetchingGroups: state.groups.fetchingGroups,
  groups: state.groups.groups,
  subGroups: state.groups.subGroups,
  systemGroups: state.groups.systemGroups,
  numberOfGroups: state.groups.numberOfGroups,
  numberOfPeople: state.people.numberOfPeople,
  numberOfGroupPeople: state.groups.numberOfGroupPeople,
  totalNumberOfPeople: state.people.totalNumberOfPeople,
  totalNumberOfGroupPeople: state.groups.totalNumberOfGroupPeople,
  personAdded: state.people.personAdded,
  pageTitle: state.preferences.pageTitle,
  fetchedGroupId: state.groups.fetchedGroupId,
  groupName: state.groups.groupName,
  groupType: state.groups.groupType,
  parentGroupId: state.groups.parentGroupId,
  parentGroupName: state.groups.parentGroupName,
  fetchingPerson: state.people.fetchingPerson,
  uploadedPeople: state.people.uploadedPeople,
  peopleLimit: state.people.peopleLimit,
  peoplePage: state.people.peoplePage,
  uploadingPeopleFromFile: state.people.uploadingPeopleFromFile,
  peopleUploaded: state.people.peopleUploaded,
  uplodPeopleError: state.people.uplodPeopleError,
  fileName: state.people.fileName,
  peopleQuery: state.people.query,
  groupQuery: state.groups.query,
  status: state.user.status,
  email: state.user.email,
  msisdn: state.user.msisdn,
  requestingVerifyToken: state.user.requestingVerifyToken,
  verificationCodeRequested: state.user.verificationCodeRequested,
  verifyingUser: state.user.verifyingUser,
});

const mapDispatchToProps = (dispatch) => ({
  addPerson: (data, limit, page, userId, intl, siteLanguage) => {
    dispatch(addPerson(data, limit, page, userId, intl, siteLanguage));
  },
  addGroup: (data, userId, intl, siteLanguage) => {
    dispatch(addGroup(data, userId, intl, siteLanguage));
  },
  fetchGroups: (userId, intl, siteLanguage) => {
    dispatch(fetchGroups(userId, intl, siteLanguage));
  },
  fetchPeople: (userId, limit, page, intl, siteLanguage, query) => {
    dispatch(fetchPeople(userId, limit, page, intl, siteLanguage, query));
  },
  signOutUser: (userId, intl, siteLanguage) => {
    dispatch(signOutUser(userId, intl, siteLanguage));
  },
  deleteGroup: (uuid, userId, intl, siteLanguage, match) => {
    dispatch(deleteGroup(uuid, userId, intl, siteLanguage, match));
  },
  updateGroup: (uuid, data, userId, intl, siteLanguage) => {
    dispatch(updateGroup(uuid, data, userId, intl, siteLanguage));
  },
  uploadPeopleFromFile: (data, limit, page, userId, intl, siteLanguage) => {
    dispatch(
      uploadPeopleFromFile(data, limit, page, userId, intl, siteLanguage)
    );
  },
  uploadPeopleFromFileConfirm: (
    data,
    limit,
    page,
    userId,
    intl,
    siteLanguage
  ) => {
    dispatch(
      uploadPeopleFromFileConfirm(data, limit, page, userId, intl, siteLanguage)
    );
  },
  verifyVerificationCode: (code, intl, siteLanguage) => {
    dispatch(verifyVerificationCode(code, intl, siteLanguage));
  },
  requestVerificationCode: (
    userId,
    intl,
    siteLanguage,
    type,
    email,
    phoneNubmer
  ) => {
    dispatch(
      requestVerificationCode(
        userId,
        intl,
        siteLanguage,
        type,
        email,
        phoneNubmer
      )
    );
  },
});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(MainLayout))
);
